import { useTranslation } from 'react-i18next';

import { Flex } from '@/lib/v2/components/Layout/Stack';

import { IFreeTrialDemo } from '@/src/presentation/types/interfaces/IFreeTrialDemo';

export const DemoTrialCounter = ({ freeTrialBlock }: { freeTrialBlock?: IFreeTrialDemo }) => {
  const { t } = useTranslation();
  return (
    <div className="inline-block text-[14px]">
      <Flex noGrow withGap gapSize="small">
        <p className="subheading text-gray-600"> {t('DASHBOARD.DemoFreeTrialFinished')}</p>
        <div className="rounded-md bg-[#e04527] px-2.5 py-1.5 text-white">
          {freeTrialBlock?.counter} {t('DASHBOARD.days')}
        </div>
      </Flex>
    </div>
  );
};
